import { useEffect } from 'react';

var configuration = {
    logError: console.error
};

function addScript(callback) {
    var script = document.createElement('script');
    callback(script);
    document.body.appendChild(script);
    return function () {
        try {
            document.body.removeChild(script);
        }
        catch (error) {
            configuration.logError('Error cleaning up script:', error);
        }
    };
}

function ExternalScript(props) {
    useEffect(function () {
        return addScript(function (script) {
            script.src = props.url;
            script.defer = typeof props.defer === 'undefined' ? false : props.defer;
            script.async = typeof props.async === 'undefined' ? true : props.async;
        });
    }, [props.url, props.defer, props.async]);
    return null;
}

function InlineScript(props) {
    useEffect(function () {
        return addScript(function (script) {
            script.type = props.type;
            script.innerHTML = props.code;
        });
    }, [props.type, props.code]);
    return null;
}

export { ExternalScript, InlineScript, configuration };
//# sourceMappingURL=index.esm.js.map
